jQuery(document).ajaxSuccess(function() {
    jQuery('.lozad').each(function(){
        var src = jQuery(this).attr('data-src');
        jQuery(this).attr('src', src);
    });
    if( jQuery('.facetwp-load-more').css('display') == 'none') {
        jQuery('.facetwp-load-more').parentsUntil('.cta').hide();
    }
});
